module.exports = __webpack_public_path__ + "KlarnaLogoFullBlack.1fb76c619c27c790cafdccb140f1b266.svg";